import {AbstractViewModelTemplate} from "@mvvm/view_model/AbstractViewModelTemplate";
import {EntryFormView} from "@mvvm/view/recruit/EntryFormView";
import {EntryFormModel} from "@mvvm/model/recruit/EntryFormModel";

/**
 * 採用エントリーのフォームの ViewModel。
 * 送信の前に入力を検証し、違反があれば送信を止めてエラーを出す（最終的な検証はサーバ側）。
 */
export class EntryFormViewModel extends AbstractViewModelTemplate {
    readonly #view: EntryFormView;
    readonly #model: EntryFormModel;

    public constructor(view: EntryFormView, model: EntryFormModel = new EntryFormModel()) {
        super();
        this.#view = view;
        this.#model = model;
    }

    public async mediate(): Promise<void> {
        this.#view.onSubmit(() => {
            this.#model.update(this.#view.readInput());
            this.#view.showErrors(this.#model.errorMessages);

            return this.#model.isValid;
        });
    }
}
